import * as echarts from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { LineChart, BarChart } from "echarts/charts";
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  GraphicComponent,
} from "echarts/components";
import { format, graphics, setCaption } from "./functions/echarts-functions";
import { resize2 } from "./functions/resize-functions";
import { COLORS } from "./constants/constants";

echarts.use([
  CanvasRenderer,
  LineChart,
  BarChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  GraphicComponent,
]);
const w17 = {
  name: "echart_w17",
  options: {
    color: COLORS,
    backgroundColor: !data.color ? "#fff" : data.color,
    textStyle: {
      fontFamily: '"Montserrat", sans-serif',
    },
    title: {
      text: data.title,
      left: "left",
      textStyle: {
        fontSize: 12,
      },
    },
    tooltip: {
      confine: true,
      trigger: "axis",
      textStyle: {
        fontWeight: "600",
        fontSize: 10,
      },
      formatter: function (params) {
        let resTooltip = params[0].name + "<br/>";
        params.forEach(function (el) {
          const valRef = el.value;
          if (valRef) {
            const styles = data.styles[el.seriesIndex].split("-");
            resTooltip =
              resTooltip +
              el.marker +
              el.seriesName +
              " " +
              format(
                el.value,
                styles[0],
                styles[1],
                data.series[el.seriesIndex].currency
              ) +
              "<br/>";
          }
        });
        return resTooltip;
      },
    },
    grid: {
      right: 10,
      left: 10,
      top: data.title ? (data.title.match(/\n/g) || []).length * 15 + 16 : 10,
      bottom: 50,
    },
    legend: {
      type: "scroll",
      data: data.series.map((e) => {
        return e.name;
      }),
      top: "bottom",
      textStyle: {
        fontSize: 10,
      },
    },
    xAxis: [
      {
        type: "category",
        axisTick: {
          alignWithLabel: true,
        },
        data: data.xAxisNames,
      },
    ],
    yAxis: data.singleAxis
      ? [
          {
            type: "value",
            // name: data.title,
            splitNumber: 3,
            axisLine: {
              show: true,
              lineStyle: {
                color: COLORS[0],
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              formatter: function (vv) {
                const styles = data.styles[0].split("-");
                return format(
                  vv,
                  styles[0],
                  styles[1],
                  data.series[0].currency
                );
              },
            },
            min: function (value) {
              const m = value.min < 0 ? 1.03 : 0.97;
              let minRet = 0;
              if (value.min < 10) {
                minRet = (value.min * m).toPrecision(2);
              } else {
                minRet = Math.round(value.min * m);
              }
              return minRet;
            },
            max: function (value) {
              const m = value.max < 0 ? 0.97 : 1.03;
              let maxRet = 0;
              if (value.max < 10) {
                maxRet = (value.max * m).toPrecision(2);
              } else {
                maxRet = Math.round(value.max * m);
              }
              return maxRet;
            },
          },
        ]
      : data.series.map((e, idx) => {
          return {
            type: "value",
            // name: e.name + (e.scaleText ? "\n(" + e.scaleText + ")" : ""),
            position: e.position,
            offset: e.offset,
            splitNumber: 3,
            axisLine: {
              show: false,
              lineStyle: {
                color: COLORS[idx],
              },
            },
            axisLabel: {
              show: false,
              formatter: function (vv) {
                const styles = data.styles[idx].split("-");
                return format(vv, styles[0], styles[1], e.currency);
              },
            },
            min: function (value) {
              const m = value.min < 0 ? 1.03 : 0.97;
              let minRet = 0;
              if (value.min < 10) {
                minRet = (value.min * m).toPrecision(2);
              } else {
                minRet = Math.round(value.min * m);
              }
              return minRet;
            },
            max: function (value) {
              const m = value.max < 0 ? 0.97 : 1.03;
              let maxRet = 0;
              if (value.max < 10) {
                maxRet = (value.max * m).toPrecision(2);
              } else {
                maxRet = Math.round(value.max * m);
              }
              return maxRet;
            },
          };
        }),
    series: data.series.map((e, idx) => {
      return {
        name: e.name,
        type: e.type,
        data: e.data,
        symbol: 'roundRect',
        symbolSize: 3,
        yAxisIndex: data.singleAxis ? 0 : e.yAxisIndex,
        connectNulls: true,
      };
    }),
  },
  init: function () {
    graphics[this.name] = echarts.init(document.getElementById(this.name));
    graphics[this.name].setOption(this.options);
    setCaption(this.name, data.source)
    resize2();
  },
};

w17.init();
